// src/hooks/useThrottle.ts
import { useRef, useEffect, useCallback } from 'react';
export function useThrottle<T extends (...args: any[]) => any>(
  callback: T,
  delay: number
): T {
  const latestTimeout = useRef<NodeJS.Timeout | null>(null);
  const latestCallback = useRef(callback);
  useEffect(() => {
    latestCallback.current = callback;
  }, [callback]);
  return useCallback((...args: Parameters<T>): ReturnType<T> | undefined => {
    if (!latestTimeout.current) {
      const result = latestCallback.current(...args);
      latestTimeout.current = setTimeout(() => {
        latestTimeout.current = null;
      }, delay);
      return result;
    }
    return undefined;
  }, [delay]) as T;
}
